import { createContext } from 'react'
import { useInstantSearch } from 'react-instantsearch'

import type {
  TaggingContextType,
  TaggingProviderProps,
  TaggingTableSelectionContextType,
} from './TaggingProvider.types'
import { useTaggingTable } from './useTaggingTable'

export const TaggingContext = createContext<TaggingContextType | null>(null)
export const TaggingTableSelectionContext =
  createContext<TaggingTableSelectionContextType | null>(null)

export const TaggingProvider = (props: TaggingProviderProps) => {
  const { children, hits } = props
  const { refresh } = useInstantSearch()
  const hook = useTaggingTable({
    hits,
    refresh,
  })
  const {
    isRowSelected,
    rowSelection,
    selectedCount,
    selectedRowIds,
    setRowSelection,
    ...tagging
  } = hook
  const selection = {
    isRowSelected,
    rowSelection,
    selectedCount,
    selectedRowIds,
    setRowSelection,
  }

  return (
    <TaggingContext.Provider value={tagging}>
      <TaggingTableSelectionContext.Provider value={selection}>
        {children}
      </TaggingTableSelectionContext.Provider>
    </TaggingContext.Provider>
  )
}
